import { get } from 'lodash';
import { APIS_BASE_URL } from '../constants/env';
import { INVOICE_CONSTANTS } from '../constants';

export const getShipmentInvoiceDownloadUrl = shipmentId =>
  `${APIS_BASE_URL}/shipments/${shipmentId}/invoice`;

export const filterExportReasons = (exportReasons = []) =>
  exportReasons.reduce((acc, { code: value, description: label }) => {
    if (INVOICE_CONSTANTS.DEFAULT_REASONS.includes(value)) {
      acc.push({ label, value });
    }

    return acc;
  }, []);

export const getDefaultIsBusiness = (shipment, organisationPath) => {
  const organisation = get(shipment, organisationPath);

  return !!organisation;
};
